<div id="edgefinityHeaderPane" class="edgefinityBorder navHeader">
  <nav class="navbar navbar-inverse">

    <div class="navbar-header">
      <!-- Logo / Home Navigation Link-->
      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#defaultNavbar1">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <a class="navbar-brand" [routerLink]="['/home']">
        <img alt="Brand" src="assets/images/edgefinityCI.png">
      </a>

    </div>

    <!-- Server up/down -->
    <div class="d-flex justify-content-around align-items-center">
      <div id="serverStatus">
        <ng-container *ngIf="serverStatus == true">
          <!-- <span class="btn-floating btn-info"><i class="fa fa-circle"></i></span> -->
        </ng-container>
        <ng-container *ngIf="serverStatus == false">
          <span class="btn-floating btn-danger pulse"><i class="fa fa-exclamation-circle"></i>&nbsp;SERVER DOWN</span>
        </ng-container>
      </div>
    </div>


    <div class="collapse navbar-collapse" id="defaultNavbar1">
      <ul class="nav navbar-nav navbar-right">
        <!-- Version Header -->
        <li>
          <div id="headerVersion">{{ headerDate | date: 'MM.dd.yyyy' }}</div>
        </li>

        <!-- Active Alerts Counter -->
        <ng-container *ngIf="isLicenseValid()">
          <li class="dropdown" id="dialogNotificationIcon">
            <a [routerLink]="['/security']" class="edgefinityNavLink">
              <i class="fa fa-comments"></i>
              <span id="dialogNotificationBadge" *ngIf="mAlertCount > 0" style="display: inline;" class="badge badge-error badge-round">{{mAlertCount}}</span>
            </a>
          </li>
        </ng-container>

        <!-- Profile menu/dropdown -->
        <li class="dropdown">
          <a [routerLink]="" class="dropdown-toggle" data-toggle="dropdown">
            <i class="fa fa-user" aria-hidden="true"></i> PROFILE
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          </a>
          <ul class="dropdown-menu" id="profileDropDown">
            <li>
              <div class="navbar-login" style="width: 200px">
                <div class="row">
                  <div class="col-lg-4">
                    <p class="text-center">
                      <img id="profileHeaderUserImage" [src]="getPathForUserImage()" width="85" height="85" />
                    </p>
                  </div>
                  <div class="col-lg-8">
                    <p class="text-left">
                      <strong>
                        <span id="profileHeaderUserName">{{getAuthServiceUser().firstName}} {{getAuthServiceUser().lastName}}</span>
                      </strong>
                    </p>
                    <p class="text-left small">
                      <span id="profileHeaderEmail">{{getAuthServiceUser().email}}</span>
                    </p>
                    <ng-container *ngIf="isLicenseValid()">
                      <p class="text-left">
                        <a (click)="editProfileClicked()" class="btn btn-primary btn-block btn-sm">
                          <i class="fa fa-pencil" aria-hidden="true"></i> MANAGE PROFILE</a>
                      </p>
                    </ng-container>
                  </div>
                </div>
              </div>
            </li>
            <li class="divider"></li>
            <li>
              <div class="navbar-login navbar-login-session">
                <div class="row">
                  <div class="col-lg-12">
                    <p>
                      <a (click)="logoutClicked()" class="btn btn-default btn-block">
                        <i class="fa fa-sign-out" aria-hidden="true"></i> LOG OUT</a>
                    </p>
                  </div>

                </div>
              </div>
            </li>
          </ul>
        </li>

        <!-- System menu/dropdown -->
        <ng-container *ngIf="isLicenseValid() && systemLinks.length > 0">
          <li role="presentation" class="dropdown">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-cog" aria-hidden="true"></i> 
              SYSTEM
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </a>

            <ul class="dropdown-menu" id="configurationPicker">
              <li *ngFor="let link of systemLinks"
                [role.seperator]="link.isDivider" [class.divider]="link.isDivider"
                [class.navItem]="!link.isDivider"
                >
                <a *ngIf="!link.isDivider && link.externalHref"
                  class="edgefinityNavLink"
                  [href]="link.externalHref"
                  target="_blank">
                  <i [class]="link.iconClasses" aria-hidden="true"></i>
                  <span class="nav-text"> {{ link.name }}</span>
                </a>
                <a *ngIf="!link.isDivider && !link.externalHref"
                  class="edgefinityNavLink"
                  [routerLink]="link.path"
                  >
                  <i [class]="link.iconClasses" aria-hidden="true"></i>
                  <span class="nav-text"> {{ link.name }}</span>
                </a>
              </li>
            </ul>
        </ng-container>


      </ul>
    </div>
  </nav>
  <div *ngIf="licensingExpirationDate != null" id="licensingExpirationDate">
    <div id="licenseLabel" class="label label-danger" style="position: relative; top: -50px"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      WARNING: Edgefinity IoT license expiring on {{ licensingExpirationDate | date }}.
      Please contact your System Administrator.</div>
  </div>
</div>
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
